import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GenericAbsService } from '../utils/generic-abs-service';
import { ApiResponse, ProductCriteria, ProductDto, ProductUnitDto } from '../objects';
import { moduleConfigToken, AbdaliModuleConfig } from '../app.module';

@Injectable()
export class ProductService extends GenericAbsService<ApiResponse> {

    constructor(@Inject(moduleConfigToken) private config: AbdaliModuleConfig, private http: HttpClient) {
        super(config.baseUrl, http);
    }

    getByCriteria(criteria: ProductCriteria, headers?: HttpHeaders) {
        let endpoint = '/api/v1/product';
        endpoint = `${endpoint}?categoryId=${criteria.categoryId ? criteria.categoryId : ''}`;

        if (criteria.fromPrice) {
            endpoint = `${endpoint}&fromPrice=${criteria.fromPrice}`;
        }
        if (criteria.id) {
            endpoint = `${endpoint}&id=${criteria.id}`;
        }
        if (criteria.productName) {
            endpoint = `${endpoint}&productName=${criteria.productName}`;
        }
        if (criteria.subCategoryId) {
            endpoint = `${endpoint}&subCategoryId=${criteria.subCategoryId}`;
        }
        if (criteria.toPrice) {
            endpoint = `${endpoint}&toPrice=${criteria.toPrice}`;
        }
        endpoint = `${endpoint}&pageIndex=${criteria.pageIndex ? criteria.pageIndex : ''}&pageSize=${criteria.pageSize ? criteria.pageSize : ''}`;

        return this.getAll(endpoint, headers);
    }

    getProductById(id: number, headers?: HttpHeaders) {
        const endpoint = '/api/v1/product'
        return this.getById(endpoint, id, headers);
    }

    getProductsByName(name: string, headers?: HttpHeaders) {
        const endpoint = `/api/v1/product/${name}`;
        return this.getAll(endpoint, headers);
    }

    addProduct(dto: ProductDto, files: Array<File>, headers?: HttpHeaders) {
        const endpoint = '/api/v1/product';
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }

        dto.description = dto.description == null ? '' : dto.description;
        dto.name = dto.name == null ? '' : dto.name;
        dto.subTitle = dto.subTitle == null ? '' : dto.subTitle;

        const formData = new FormData();
        formData.append('categoryId', dto.categoryId.toString());
        formData.append('subCategoryId', dto.subCategoryId.toString());
        formData.append('name', dto.name);
        formData.append('description', dto.description);
        formData.append('productUnitId', dto.productUnitId.toString());
        formData.append('quantity', dto.quantityPerUnit.toString());
        formData.append('unitPrice', dto.unitPrice.toString());
        formData.append('subTitle', dto.subTitle);
        formData.append('searchField', dto.searchField);
        if (files && files.length > 0) {
            for (const f of files) {
                formData.append('files', f, f.name);
            }
        }

        return this.post(endpoint, formData, headers);
    }

    updateProduct(dto: ProductDto, files: Array<File>, headers?: HttpHeaders) {
        const endpoint = '/api/v1/product';
        // if (headers) {
        //     if (headers.has('Content-Type') === false) {
        //         headers.append('Content-Type', 'application/multipart-form');
        //     }
        // }
        // else {
        //     headers = new HttpHeaders({
        //         'Content-Type': 'application/multipart-form'
        //     });
        // }
        dto.description = dto.description == null ? '' : dto.description;
        dto.name = dto.name == null ? '' : dto.name;
        dto.subTitle = dto.subTitle == null ? '' : dto.subTitle;

        const formData = new FormData();
        formData.append('id', dto.id.toString());
        formData.append('categoryId', dto.categoryId.toString());
        formData.append('subCategoryId', dto.subCategoryId.toString());
        formData.append('name', dto.name);
        formData.append('description', dto.description);
        formData.append('productUnitId', dto.productUnitId.toString());
        formData.append('quantity', dto.quantityPerUnit.toString());
        formData.append('unitPrice', dto.unitPrice.toString());
        formData.append('productStatusId', dto.productStatusId.toString());
        formData.append('subTitle', dto.subTitle);
        formData.append('searchField', dto.searchField);
        if (files && files.length > 0) {
            for (const f of files) {
                formData.append('files', f, f.name);
            }
        }

        return this.put(endpoint, formData, headers);
    }

    getProductUnits(headers?: HttpHeaders) {
        const endpoint = '/api/v1/product/units';
        return this.getAll(endpoint, headers);
    }

    getProductUnitById(id: number) {
        const endpoint = '/api/v1/product/units';
        return this.getById(endpoint, id);
    }

    insertProductUnit(dto: ProductUnitDto) {
        const endpoint = '/api/v1/product/units';
        return this.post(endpoint, dto);
    }

    updateProductUnit(dto: ProductUnitDto) {
        const endpoint = '/api/v1/product/units';
        return this.put(endpoint, dto);
    }

    getProductStatus(headers?: HttpHeaders) {
        const endpoint = '/api/v1/product/units/status';
        return this.getAll(endpoint, headers);
    }

}
